<template>
  <div style="background:#fff"
       v-if="isLogin">
    <div class="img-box">
      <div class="avatar"
           :style="{ backgroundImage: 'url(' +headImg + ')'}"></div>
      <div class="nick-name">@{{nickName}}</div>
    </div>
    <a class="btn"
       href="javascript:void(0);"
       @click="handlePreviewImage">预览并保存</a>
    <canvas id="J_canvas"
            style="width: 100%;height: 1269rpx;background:#fff;position: fixed;top: -10000px;" />
  </div>
  <!-- <div>
    <a class="btn"
       href="javascript:void(0);"
       @click="handlePreviewImage">预览并保存</a>
    <img :src="imgSrc"
         width="300"
         @click="previewImage(imgSrc)"
         height="500" />
    <canvas id="J_canvas"
            style="width: 100%;height: 1269rpx;background:#fff;position: fixed;top: -10000px;" />
  </div> -->
</template>
<script>
import wx from 'weixin-js-sdk'
import axios from 'axios'
import Cookies from 'js-cookie'
export default {
  name: 'BossImage',
  mixins: [],
  components: {},
  props: {},
  data () {
    return {
      appId: 'wx1f18c37d2339686f',
      openId: null,
      nickName: null,
      headImg: null,
      ready: false,
      imgSrc: null
    }
  },
  computed: {
    // 是否是微信浏览器
    isWebChat () {
      return /micromessenger/.test(navigator.userAgent.toLowerCase())
    },
    isLogin () {
      return this.openId && this.nickName && this.headImg
    }
  },
  watch: {},
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.redirecUrl = `http://${window.location.host}/#${to.fullPath}`
      let openId = Cookies.get('openIdBoss')
      let timeStr = Cookies.get('redirectBoss')
      if (vm.isWebChat) { // 是微信环境
        if (!openId && !timeStr) {
          Cookies.set('redirectBoss', 1)
          vm.redirectWX()
        } else {
          if (Cookies.get('failBoss')) {  // 未授权
            this.$wejs.alert('请进行授权登录')
          } else {  // 正常
            vm.openId = openId
            vm.nickName = Cookies.get('nicknameBoss')
            vm.headImg = Cookies.get('headimgurlBoss')
            // 移除登录凭证
            Cookies.remove('nicknameBoss')
            Cookies.remove('headimgurlBoss')
            Cookies.remove('openIdBoss')
            Cookies.remove('redirectBoss')
            Cookies.remove('failBoss')
            vm.init()
          }
        }
      }
    })
  },
  created () {
  },
  mounted () { },
  destroyed () { },
  methods: {
    async init () {
      let json = await this.getJsSDK()
      let defaultConfig = {
        appId: '', // 必填，公众号的唯一标识
        timestamp: '', // 必填，生成签名的时间戳
        nonceStr: '', // 必填，生成签名的随机串
        signature: '', // 必填，签名
        jsApiList: [
          'onMenuShareTimeline', // 分享到朋友圈
          'onMenuShareAppMessage', // 分享给朋友
          'onMenuShareQQ', // 分享到QQ
          'onMenuShareWeibo', // 分享到腾讯微博
          'onMenuShareQZone' // 分享到QQ空间
        ]
      }
      wx.config({ ...defaultConfig, ...json })
      wx.ready(() => {
        this.ready = true
      })
    },
    async getJsSDK () {
      let url = `http://boss-image.yuanbei.biz/WeixinJSSDK/SdkSignature?url=${window.location.href}`
      let json = await axios.get(url)
      return json.data
    },
    handleShareTimeline () {
      if (!this.ready) {
        this.$wejs.alert('环境初始化中，请稍后重试')
      } else {
        wx.updateTimelineShareData({
          title: 'boss-share', // 分享标题
          link: 'http://fe-boss-image.yuanbei.biz/#/boss-image', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: 'http://a.hiphotos.baidu.com/image/h%3D300/sign=b38f3fc35b0fd9f9bf175369152cd42b/9a504fc2d5628535bdaac29e9aef76c6a6ef63c2.jpg', // 分享图标
          success: function () {
            // 设置成功
          }
        })
      }
    },
    handlePreviewImage () {
      this.$wejs.alert('请长按图片并保存', async () => {
        // 请求接口数据
        let loadingInstance = this.$wejs.loading('请求数据中')
        try {
          let json = await axios.post('http://draw-boss-image.yuanbei.biz/drawing/share', {
            'ImageUrl': this.headImg,
            'NickName': this.nickName,
            'OpenId': this.openId
          })
          loadingInstance.hide()
          wx.previewImage({
            current: json.data + '!large',
            urls: [json.data + '!large']
          })
        } catch (error) {
          this.$wejs.toast(error)
        }
      })
    },
    redirectWX () {
      let url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + this.appId +
        '&redirect_uri=' + encodeURIComponent(this.redirecUrl) +
        '&response_type=code&scope=snsapi_userinfo&state=#wechat_redirect'
      window.location.replace(url)
    },
    // 获取页面dpr和宽度
    getWindowInfo () {
      var windowInfo = {}
      windowInfo.dpr = window.devicePixelRatio
      if (window.innerWidth) {
        windowInfo.width = window.innerWidth
      } else {
        windowInfo.width = document.body.clientWidth
      }
      return windowInfo
    },
    // 拿到数据后开始画背景大图 想法很简单就是把图片画到canvas中然后在画布上再画头像文字让后转成img
    drawCanvasBgImg () {
      let vm = this
      let canvas = document.getElementById('J_canvas')
      let ctx = canvas.getContext('2d')
      // eslint-disable-next-line no-irregular-whitespace
      let clientWidth = this.getWindowInfo().width  // 获取屏幕宽度用于canvas宽度自适应移动端屏幕
      let dpr = this.getWindowInfo().dpr
      ctx.globalCompositeOperation = 'source-atop'//* * 坑锯齿感觉没什么用不知道是不是用错地方了 **
      // eslint-disable-next-line no-irregular-whitespace
      canvas.width = dpr * clientWidth  // 由于手机屏幕时retina屏，都会多倍渲染，用dpr来动态设置画布宽高，避免图片模糊
      canvas.height = dpr * clientWidth * 609 / 375// 去掉微信头部的状态栏应该是603 没搞懂603还是不能让图片满屏直接多加到了609
      var img = new Image()
      img.crossOrigin = ''// 死坑的图片跨域 （img.crossOrigin = "Anonymous"这种写法还是不能显示base64格式图片）
      img.src = require('../../assets/images/boss/bg.jpg')
      img.onload = function () {
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
        // vm.drawCanvasUserImg(canvas, ctx, dpr)
        vm.convertCanvasToImage(canvas)
      }
    },
    // 在背景图片的画布上截取一个圆然后填充入用户头像
    drawCanvasUserImg: function (canvas, ctx, dpr) {
      var vm = this
      var circleR = 44 * dpr// 半径
      var circleX = canvas.width / 2// 圆心X坐标
      var circleY = 44 * dpr// 圆心Y坐标
      var imgX = circleX - circleR// 图片X开始坐标
      var imgY = circleY - circleR// 图片Y开始坐标
      var imgWidth = 2 * circleR// 图片按圆形大小
      var img = new Image()
      img.crossOrigin = ''
      img.src = this.headImg
      img.onload = function () {
        ctx.save() // 保存当前ctx的状态
        ctx.arc(circleX, circleY, circleR, 0, 2 * Math.PI) // 画出圆
        ctx.clip() // 裁剪上面的圆形
        ctx.drawImage(img, imgX, imgY, imgWidth, imgWidth) // 在刚刚裁剪的园上画图
        ctx.restore() // 还原状态
        // vm.canvasFillText(canvas, ctx, dpr, circleR)
        vm.convertCanvasToImage(canvas)
      }
    },
    // 填写用户称呢或者用户留言
    canvasFillText (canvas, ctx, dpr, circleR) {
      var fontSizeThis = dpr * 20 + 'px' + ' Arial'
      var userNameY = 0// 用户名Y轴坐标
      var userMessageX = dpr * 40// 用户留言X轴坐标
      var userMessageY = 0// 用户留言Y轴坐标
      var lastSubStrIndex = 0// 字符串下标
      var lineWidth = 0// 一行宽度
      var allTextWidth = 0// 所有字符宽度
      ctx.font = fontSizeThis
      // 需要用户名是写入用户名
      if (this.nickName) {
        userNameY = circleR * 2.5
        ctx.fillStyle = '#0094ff'
        ctx.textAlign = 'center'
        ctx.fillText(this.userName, canvas.width / 2, userNameY)
      }
      if (this.userMessage) {
        userMessageY = userNameY + dpr * 35
        ctx.fillStyle = '#000'
        // 获取字符宽度
        for (let i = 0; i < this.userMessage.length; i++) {
          allTextWidth += ctx.measureText(this.userMessage[i]).width
        }
        // 字符串长度大于画布区域要换行
        if (allTextWidth > canvas.width - 2 * userMessageX) {
          for (let i = 0; i < this.userMessage.length; i++) {
            lineWidth += ctx.measureText(this.userMessage[i]).width
            if (lineWidth > canvas.width - 2 * userMessageX) {
              ctx.textAlign = 'left'
              ctx.fillText(this.userMessage.substring(lastSubStrIndex, i), userMessageX, userMessageY)
              userMessageY += dpr * 25// 设置行高
              lineWidth = 0
              lastSubStrIndex = i
            }
            if (i === this.userMessage.length - 1) {
              ctx.fillText(this.userMessage.substring(lastSubStrIndex, i + 1), userMessageX, userMessageY)
            }
          }
        } else {
          // 小于者居中显示
          ctx.textAlign = 'center'
          ctx.fillText(this.userMessage, canvas.width / 2, userMessageY)
        }
      }
      this.convertCanvasToImage(canvas)
    },
    // 合成base64位分享图
    convertCanvasToImage (canvas) {
      console.log(canvas.toDataURL('image/jpeg'))
      let src = canvas.toDataURL('image/jpeg')// png有毒在安卓机下识别二维码无法跳转
      this.imgSrc = src
    },
    previewImage (src) {
      wx.previewImage({
        current: src,
        urls: [src] // 需要预览的图片http链接列表
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/base/_mixin';
.img-box {
  position: relative;
  margin: px2rem(30px) auto;
  width: px2rem(710px);
  height: px2rem(1120px);
  background: url('../../assets/images/boss/bg.jpg') center top no-repeat;
  background-size: cover;
}

.avatar {
  position: absolute;
  left: px2rem(66px);
  top: px2rem(933px);
  width: px2rem(88px);
  height: px2rem(88px);
  border-radius: 50%;
  border: 1px solid #000;
  background-size: 100% 100%;
}

.nick-name {
  left: px2rem(161px);
  top: px2rem(945px);
  position: absolute;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  font-size: px2rem(23px);
}

.btn {
  position: relative;
  display: block;
  width: 184px;
  margin-left: auto;
  margin-right: auto;
  padding: 8px 24px;
  box-sizing: border-box;
  font-weight: 700;
  font-size: 17px;
  text-align: center;
  text-decoration: none;
  color: #fff;
  line-height: 1.41176471;
  border-radius: 4px;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  overflow: hidden;
  background-color: #07c160;
}
</style>



// WEBPACK FOOTER //
// index.vue?423e30cd